module.exports = __webpack_public_path__ + "static/media/tjuv.eca3ab99.m4a";